import { render, staticRenderFns } from "./SettingsIndexesAddSourceButton.vue?vue&type=template&id=77e1ee2d&"
import script from "./SettingsIndexesAddSourceButton.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexesAddSourceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports